import {createContext} from '@lit/context';
export const subscriberKeyContext = createContext<number>('subscriber-key');